import opencityCreator from './creator';

export default opencityCreator;
